import React from "react";

const PurchaseManagement = () => {
  return (
    <div className="w-full bg-white shadow-md rounded-xl p-6 font-poppins">
      <div className="pr-10">
        <h2 className="font-poppins font-semibold text-20 leading-5 text-black mb-4">
          Direct Purchase Management
        </h2>
        <p className="font-poppins font-normal text-16 leading-2 text-[#656565] mb-7">
          Manage physical gold purchase requests that meet minimum quantity
          requirement.
        </p>

        <div className="pr-[23%]">
          <div className="flex justify-between items-center bg-white shadow-lg rounded-lg px-4 py-3 mb-3">
            <div>
              <p className="font-poppins font-medium text-16 leading-4 text-black mb-1">
                New Purchase
              </p>
              <p className="font-poppins font-normal text-14 leading-3 text-[#656565">
                5 pending approval
              </p>
            </div>
            <span className="font-poppins font-medium text-12 leading-4 text-[#003265] border border-[#54A5F5] bg-[#E6F2FE] rounded-lg px-3 py-1">
              NEW
            </span>
          </div>

          <div className="flex justify-between items-center bg-white shadow-lg rounded-lg px-4 py-3 mb-8">
            <div>
              <p className="font-poppins font-medium text-16 leading-4 text-black mb-1">
                In Processing
              </p>
              <p className="font-poppins font-normal text-14 leading-3 text-[#656565">
                Order
              </p>
            </div>
            <span className="text-xs font-semibold text-[#664300] border border-[#F6BF55] bg-[#FEF6E6] rounded-lg px-3 py-1">
              IN PROGRESS
            </span>
          </div>
        </div>

        <button className=" bg-primary-400 text-white w-7/12 py-4 px-4  font-poppins font-medium text-16 leading-4 rounded-md transition">
          Manage Purchase Requests
        </button>
      </div>
    </div>
  );
};

export default PurchaseManagement;
